import React, {Component} from "react";

class TextField extends Component {

    onChange(e){
        if (typeof(this.props.onChange) === "function") {
            this.props.onChange(e);
        }
    }

    render() {

        const {id,title,placeholder,value,required} = this.props;

        return (
            <div key={id} className={"inputFieldWrapper textField"}>
                <label htmlFor={id}>
                    {title}
                </label>
                <input
                    type="text"
                    name={id}
                    id={id}
                    placeholder={placeholder}
                    onChange={(e)=>this.onChange(e)}
                    required={required}
                    value={value || ''}
                />
            </div>
        )
    }
}

export default TextField;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/Form_Elements/TextField.js